<script setup>
import { ref, onMounted } from 'vue'
import { useWorkspaceStore } from '../stores/workspace'

const emit = defineEmits(['switch'])

const workspaceStore = useWorkspaceStore()
const showNew = ref(false)
const newName = ref('')

onMounted(async () => {
  await workspaceStore.fetchWorkspaces()
  // 如果没有工作空间，自动创建一个
  if (workspaceStore.workspaces.length === 0) {
    const ws = await workspaceStore.addWorkspace('默认工作空间')
    workspaceStore.switchWorkspace(ws.workspace_id)
  } else if (!workspaceStore.currentWorkspaceId) {
    workspaceStore.switchWorkspace(workspaceStore.workspaces[0].workspace_id)
  }
})

const handleSwitch = (wsId) => {
  workspaceStore.switchWorkspace(wsId)
  emit('switch', wsId)
}

const handleCreate = async () => {
  if (!newName.value.trim()) return
  const ws = await workspaceStore.addWorkspace(newName.value.trim())
  workspaceStore.switchWorkspace(ws.workspace_id)
  emit('switch', ws.workspace_id)
  newName.value = ''
  showNew.value = false
}

const handleDelete = async (wsId) => {
  if (workspaceStore.workspaces.length <= 1) return
  await workspaceStore.removeWorkspace(wsId)
}
</script>

<template>
  <div class="workspace-selector">
    <el-dropdown trigger="click" @command="handleSwitch">
      <span class="selector-trigger">
        <span class="ws-icon">📚</span>
        <span class="ws-name">{{ workspaceStore.currentWorkspace?.name || '选择工作空间' }}</span>
        <span class="ws-arrow">▼</span>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            v-for="ws in workspaceStore.workspaces"
            :key="ws.workspace_id"
            :command="ws.workspace_id"
          >
            <div class="ws-item">
              <span>{{ ws.name }}</span>
              <button
                v-if="workspaceStore.workspaces.length > 1"
                class="ws-delete"
                @click.stop="handleDelete(ws.workspace_id)"
              >✕</button>
            </div>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <div v-if="!showNew" class="ws-new-trigger" @click.stop="showNew = true">
              + 新建工作空间
            </div>
            <div v-else class="ws-new-form" @click.stop>
              <input
                v-model="newName"
                placeholder="工作空间名称"
                class="ws-new-input"
                @keyup.enter="handleCreate"
                autofocus
              />
              <button class="ws-new-btn" @click="handleCreate">✓</button>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<style scoped>
.workspace-selector {
  display: inline-flex;
}

.selector-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  background: white;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
  transition: all 0.15s;
}

.selector-trigger:hover {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.15);
}

.ws-icon {
  font-size: 16px;
}

.ws-name {
  font-weight: 500;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ws-arrow {
  font-size: 10px;
  color: #9ca3af;
}

.ws-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.ws-delete {
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  font-size: 11px;
  padding: 2px;
  border-radius: 3px;
}

.ws-delete:hover {
  color: #ef4444;
  background: #fef2f2;
}

.ws-new-trigger {
  color: #0ea5e9;
  cursor: pointer;
  font-size: 13px;
}

.ws-new-form {
  display: flex;
  gap: 4px;
  align-items: center;
}

.ws-new-input {
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  outline: none;
  width: 140px;
}

.ws-new-input:focus {
  border-color: #0ea5e9;
}

.ws-new-btn {
  border: none;
  background: #0ea5e9;
  color: white;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 12px;
}
</style>
